module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__mask",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__dialog"
  }, [_c('button', {
    staticClass: "modal__close close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "modal__header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal__body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal__footer"
  }, [_vm._t("footer")], 2)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7724861e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7724861e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/Modal.vue
// module id = 131
// module chunks = 0